<h4 mat-dialog-title class="mb-0 d-flex justify-content-between align-items-center">
  {{ header ? header : defaultText }}
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</h4>

<qr-code [value]="parsedValue"></qr-code>
